module.exports = __webpack_public_path__ + "media/images/athletes/2844-b576604564fb0ded8d7508f345ddbcd5.png";